import RadioInput from "../../../components/inputs/RadioInput";
import ResizableShape from "../../../components/dashboard/ResizableShape";
import { imagePreview } from "../../../helpers/images";

const SetAvatarLocationForm = ({ formData, setFormData, handleChange }) => {
  return (
    <form className="min-w-[800px] overflow-y-auto">
      <RadioInput
        label="Avatar Shape"
        name="shape"
        value={formData.imageAttribute?.shape?.toLocaleLowerCase()}
        inline
        items={[
          { id: "circle", value: "circle", text: "Circle" },
          { id: "square", value: "square", text: "Square" },
        ]}
        onChange={(val) => {
          setFormData((prevState) => ({
            ...prevState,
            imageAttribute: {
              ...prevState.imageAttribute,
              shape: val?.target?.value?.toLocaleUpperCase(),
            },
          }));
        }}
      />

      <div>
        <div className="w-full mt-2 relative max-w-[703px] resive-boundary">
          <div
            className={`absolute bg-[#f4faffcc] p-4 w-full h-full z-[1] ${
              formData.imageAttribute?.height || 100
            } ${formData.imageAttribute?.width || 100}`}
          ></div>
          <ResizableShape
            resizeType="imageAttribute"
            shape={formData.imageAttribute?.shape?.toLocaleLowerCase()}
            setFormData={setFormData}
            attributes={formData?.imageAttribute}
          />

          <img
            className="w-full h-full overflow-hidden relative"
            src={formData.bannerData || imagePreview}
            alt="Preview"
          />
        </div>
      </div>
    </form>
  );
};

export default SetAvatarLocationForm;
